import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DismissableCard } from 'LegacyWeployDesignLanguage/Card';

const Emoji = styled.h1`
  margin: 0;
  text-align: center;
`;

const CongratulationsContainer = styled.div`
  text-align: center;
`;

const CongratulationsTitle = styled.h2`
  color: ${props => props.theme.colors.darkerGrey};
  margin-bottom: ${props => props.theme.space.half};
  text-align: center;
`;

const SuccessCard = ({
  onClose,
  title,
  description,
  emojiVisible,
}) => (
  <DismissableCard onClose={onClose}>
    <CongratulationsContainer>
      { emojiVisible &&
        <Emoji><span role="img" aria-label="congratulations emoji">🎉</span></Emoji>
      }
      <CongratulationsTitle>{title}</CongratulationsTitle>
      {description}
    </CongratulationsContainer>
  </DismissableCard>
);

SuccessCard.propTypes = {
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  emojiVisible: PropTypes.bool,
};

SuccessCard.defaultProps = {
  emojiVisible: true,
};

export default SuccessCard;
